import React, { useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { LuMoveLeft, LuMoveRight } from "../../assets/logos/index";
import { useBookSection } from "../hooks/index";
import LightBox from "../components/LightBox";

const BookDetailPage = () => {
  const { id } = useParams();
  const { data, isLoading, isError, status } = useBookSection();


  const [open, setOpen] = useState(false);
  const [openSlider, setOpenSlider] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const swiperRef = useRef(null);

  const handlePrevClick = () => {
    swiperRef.current.swiper.slidePrev();
  };
  const handleNextClick = () => {
    swiperRef.current.swiper.slideNext();
  };

  if (isLoading) return <div className="spinner"></div>;
  if (status === "failed") return <div>Error: {isError}</div>;

  const book = data?.books?.find((b) => b._id === id);
  if (!book) return <div>Book not found</div>;

  return (
    <div className="App container my-5">
      <div>
        <h2 className="heading-font text-center">{book?.book_title}</h2>
        <img
          src={`${process.env.REACT_APP_BASE_IMG_URL}${book?.cover_image}`}
          onClick={() => setOpen(true)}
          alt={book?.book_title}
          className="w-100 my-4 object-fit-contain"
          style={{ height: "500px" }}
        />
        <div
          className="fw-light fs-6 lh-lg w-75 mx-auto"
          dangerouslySetInnerHTML={{ __html: book?.description }}
        />
      </div>

      <div className="py-5">
        <h3 className="heading-font text-center">
          Book Distribution and News Article
        </h3>
        <Swiper
          ref={swiperRef}
          spaceBetween={10}
          className="mySwiper mb-4"
          breakpoints={{
            400: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 4 },
          }}
        >
          {book.images.map((image, index) => (
            <SwiperSlide key={index} className="photo-gallery-slider-card">
              <img
                loading="lazy"
                src={`${process.env.REACT_APP_BASE_IMG_URL}${image}`}
                onClick={() => {
                  setPhotoIndex(index);
                  setOpenSlider(true);
                }}
                alt={`book_img-${index}`}
                className="photo-gallery-img w-100 "
              />
            </SwiperSlide>
          ))}
        </Swiper>

        <div className="d-flex justify-content-center">
          <button
            className="btn px-3 py-0 fs-2 border-0"
            onClick={handlePrevClick}
            aria-label="Previous"
          >
            <LuMoveLeft />
          </button>
          <button
            className="btn px-3 py-0 fs-2 border-0"
            onClick={handleNextClick}
            aria-label="Next"
          >
            <LuMoveRight />
          </button>
        </div>
      </div>

      <LightBox
        open={open}
        onClose={() => setOpen(false)}
        images={[`${book.cover_image}`]}
        source={process.env.REACT_APP_BASE_IMG_URL}
      />
      <LightBox
        open={openSlider}
        onClose={() => setOpenSlider(false)}
        photoIndex={photoIndex}
        images={book.images.map(
          (img) => `${img}`
        )}
        source={process.env.REACT_APP_BASE_IMG_URL}
      />
    </div>
  );
};

export default BookDetailPage;
